module.exports = __webpack_public_path__ + "img/thumbnail_CapuchinMonkey_m_normal.9caa5a25.png";